var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.modalOpen
        ? _c("SideBarModal", {
            attrs: {
              user: _vm.selectedUser,
              roles: _vm.roles,
              tags: _vm.usersTags,
              onModalClose: () => (this.modalOpen = false),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            !_vm.loading
              ? _c("ManagersList", {
                  attrs: {
                    users: _vm.users.managers,
                    assists: _vm.users.managerAssist || [],
                    editUser: _vm.openSideModal,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }